import type { PortalPhase } from '../api/contracts'

/** Il «!» accanto allo stato: il portale ha una fase per la pratica e non è un esito definitivo (chiuso, KO, stornato). */
export function showPortalDot(p: PortalPhase | null | undefined): p is PortalPhase {
  return !!p && !p.conclusiva && p.fase.trim() !== ''
}

/** Data e ora brevi del dettaglio (es. «02/11, 12:04»); vuoto se manca o non è leggibile. */
export function portalWhen(iso: string | null | undefined): string {
  if (!iso) return ''
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString('it-IT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
}

/** Riga sopra il messaggio: quando e chi l'ha scritto sul portale. */
export function portalMessageMeta(m: PortalPhase['messaggi'][number]): string {
  return [portalWhen(m.il), m.autore?.trim()].filter(Boolean).join(' · ')
}
